export default function CaseStudiesSection() {
  const caseStudies = [
    {
      title: '16-Unit Apartment Building',
      location: 'East El Paso',
      situation: 'Owner inherited the property and lived out of state. Managing from a distance was difficult, and several units needed repairs. Mix of good and problematic tenants.',
      challenge: 'Traditional buyers wanted the property vacant, which would have taken 6+ months and cost thousands in lost rent and legal fees.',
      solution: 'We purchased the property with all tenants in place, honored existing leases, and closed in 10 days.',
      result: 'Owner received $1.2M cash, avoided eviction costs, and eliminated management headaches immediately.',
      image: 'https://public.readdy.ai/ai/img_res/8c42e7ae4d9b733c6db0654a0e745886.jpg'
    },
    {
      title: 'Duplex with Section 8 Tenants',
      location: 'Central El Paso',
      situation: 'Landlord was retiring and wanted to sell quickly. Both units occupied by Section 8 tenants with valid vouchers and 18 months remaining on leases.',
      challenge: 'Most buyers don\'t want Section 8 properties or don\'t understand the program. Property also needed roof repairs.',
      solution: 'We understood Section 8 requirements, bought the property as-is with tenants staying, and coordinated with housing authority.',
      result: 'Landlord received $185,000 cash and closed in 8 days. Tenants kept their homes without disruption.',
      image: 'https://readdy.ai/api/search-image?query=duplex%20rental%20property%20two%20unit%20residential%20building%20tenant%20occupied%20side%20by%20side%20units%20section%20eight%20housing%20affordable%20rental&width=600&height=400&seq=rental-case-002&orientation=landscape'
    },
    {
      title: 'Single-Family Rental Portfolio',
      location: 'West El Paso',
      situation: 'Investor owned 8 single-family rentals scattered across the city. Wanted to sell entire portfolio at once. All properties had tenants with varying lease terms.',
      challenge: 'Selling 8 properties individually would take years. Finding one buyer for an entire portfolio with tenants is extremely difficult.',
      solution: 'We purchased all 8 properties as a package deal with all tenants remaining. Single closing for entire portfolio.',
      result: 'Investor received $1.8M for the portfolio and closed in 14 days. Eliminated management of 8 properties instantly.',
      image: 'https://readdy.ai/api/search-image?query=portfolio%20of%20single%20family%20rental%20homes%20multiple%20residential%20properties%20tenant%20occupied%20investment%20real%20estate%20suburban%20neighborhood%20houses&width=600&height=400&seq=rental-case-003&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Real Transactions, Real Results
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Here are actual examples of tenant occupied properties we've purchased in El Paso. Names and some details changed for privacy.
          </p>
        </div>

        <div className="space-y-12">
          {caseStudies.map((study, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300"
            >
              <div className="grid lg:grid-cols-2 gap-0">
                <div className="relative w-full h-96 lg:h-auto">
                  <img 
                    src={study.image}
                    alt={study.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-6 left-6 bg-teal-600 text-white px-4 py-2 rounded-lg font-bold">
                    Case Study {index + 1}
                  </div>
                </div>
                
                <div className="p-8 lg:p-12">
                  <h3 className="text-3xl font-bold text-gray-900 mb-2">{study.title}</h3>
                  <div className="flex items-center text-teal-600 mb-6">
                    <i className="ri-map-pin-fill mr-2"></i>
                    <span className="font-semibold">{study.location}</span>
                  </div>
                  
                  <div className="space-y-4">
                    <div>
                      <div className="flex items-center mb-2">
                        <i className="ri-information-fill text-gray-400 mr-2"></i>
                        <h4 className="font-bold text-gray-900">Situation:</h4>
                      </div>
                      <p className="text-gray-700 leading-relaxed pl-6">{study.situation}</p>
                    </div>
                    
                    <div>
                      <div className="flex items-center mb-2">
                        <i className="ri-alert-fill text-red-500 mr-2"></i>
                        <h4 className="font-bold text-gray-900">Challenge:</h4>
                      </div>
                      <p className="text-gray-700 leading-relaxed pl-6">{study.challenge}</p>
                    </div>
                    
                    <div>
                      <div className="flex items-center mb-2">
                        <i className="ri-lightbulb-fill text-teal-600 mr-2"></i>
                        <h4 className="font-bold text-gray-900">Our Solution:</h4>
                      </div>
                      <p className="text-gray-700 leading-relaxed pl-6">{study.solution}</p>
                    </div>
                    
                    <div className="bg-teal-50 border-l-4 border-teal-600 p-4 rounded">
                      <div className="flex items-center mb-2">
                        <i className="ri-trophy-fill text-teal-600 mr-2"></i>
                        <h4 className="font-bold text-gray-900">Result:</h4>
                      </div>
                      <p className="text-gray-700 leading-relaxed pl-6">{study.result}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-xl text-gray-600 mb-8">
            Your situation might be different, but our approach is the same: fast, professional, and secure.
          </p>
          <a 
            href="#contact"
            className="inline-flex items-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Get Your Cash Offer Today
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}